import { d as deprecated } from './6cf04c83.mjs';

function getScrollbarWidth() {
  const scrollDiv = document.createElement("div");
  let scrollbarWidth = 0;
  if (document.body.clientWidth < window.innerWidth) {
    scrollDiv.className = "p_scrollbarMeasure";
    document.body.appendChild(scrollDiv);
    scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
  }
  return scrollbarWidth;
}
function findInUserAgent(needle) {
  return window.navigator.userAgent.toLowerCase().indexOf(needle) !== -1;
}
function isIE8() {
  deprecated("o_util.browser.isIE8", "IE8 is doomed");
  return navigator.userAgent.indexOf("MSIE 8") > -1;
}
function getStyle(elem, styleProp) {
  deprecated("o_util.browser.getStyle", "use native getComputedStyle instead");
  return window.getComputedStyle(elem, null).getPropertyValue(styleProp);
}

var index = /*         */Object.freeze({
  __proto__: null,
  findInUserAgent: findInUserAgent,
  getScrollbarWidth: getScrollbarWidth,
  getStyle: getStyle,
  isIE8: isIE8
});

export { isIE8 as a, getStyle as b, findInUserAgent as f, getScrollbarWidth as g, index as i };
/*                                 */
